<template>
  <HrmisCrudModule v-bind="config" />
</template>

<script>
import HrmisCrudModule from "./HrmisCrudModule.vue";

export default {
  name: "ModuleRedesignation",
  components: { HrmisCrudModule },
  data() {
    return {
      config: {
        title: "Redesignation",
        subtitle: "Requests to change role / designation (County SR)",
        icon: "🔁",
        listFunction: "getRedesignationList",
        saveFunction: "saveRedesignation",
        permissionViewCodes: ["REDESIGNATION_VIEW", "REDESIGNATION_MANAGE"],
        permissionManageCodes: ["REDESIGNATION_MANAGE"],
        enableReports: true,
        reportTitle: "Redesignation Report",
        loadEmployees: true,
        employeeInputMode: "search",
        employeeKeywordSearch: true,
        columns: [
          { key: "employee_name", label: "Employee" },
          { key: "current_title", label: "Current" },
          { key: "proposed_title", label: "Proposed" },
          { key: "status", label: "Status" }
        ],
        fields: [
          { key: "employee_id", label: "Employee", type: "employee", required: true, lockOnEdit: true },
          { key: "current_title", label: "Current title / cadre", type: "text" },
          { key: "proposed_title", label: "Proposed title / cadre", type: "text" },
          { key: "justification", label: "Justification", type: "textarea" },
          {
            key: "status",
            label: "Status",
            type: "select",
            options: ["Draft", "Submitted", "Approved", "Rejected"],
            default: "Draft"
          }
        ]
      }
    };
  }
};
</script>
